<div class="router-outlet-wrapper">
  <router-outlet></router-outlet>
</div>
